var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.07 1.92998C9.26582 1.12416 8.24053 0.575192 7.12405 0.35264C6.00757 0.130089 4.85015 0.243972 3.79845 0.679858C2.74676 1.11574 1.84812 1.85401 1.21641 2.80112C0.584709 3.74823 0.248366 4.86154 0.250006 5.99998C0.250006 6.1989 0.329023 6.38966 0.469676 6.53031C0.610328 6.67097 0.801094 6.74998 1.00001 6.74998C1.19892 6.74998 1.38968 6.67097 1.53034 6.53031C1.67099 6.38966 1.75001 6.1989 1.75001 5.99998C1.74803 5.15659 1.99644 4.33158 2.46378 3.6295C2.93111 2.92742 3.59633 2.37985 4.37515 2.05618C5.15397 1.73251 6.01134 1.64731 6.83863 1.81136C7.66592 1.97542 8.4259 2.38135 9.02227 2.97772C9.61864 3.57409 10.0246 4.33407 10.1886 5.16136C10.3527 5.98865 10.2675 6.84602 9.94381 7.62484C9.62014 8.40366 9.07257 9.06888 8.37049 9.53621C7.66841 10.0035 6.8434 10.252 6.00001 10.25C5.8019 10.2526 5.61264 10.3324 5.47254 10.4725C5.33245 10.6126 5.2526 10.8019 5.25001 11V13C5.25001 13.1989 5.32902 13.3897 5.46968 13.5303C5.61033 13.671 5.80109 13.75 6.00001 13.75C6.19892 13.75 6.38968 13.671 6.53034 13.5303C6.67099 13.3897 6.75001 13.1989 6.75001 13V11.7C7.81305 11.5576 8.81521 11.1212 9.64363 10.44C10.472 9.75874 11.0938 8.85975 11.4389 7.84425C11.784 6.82874 11.8387 5.73706 11.5968 4.69214C11.355 3.64723 10.8262 2.6906 10.07 1.92998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6 17.75C6.69036 17.75 7.25 17.1904 7.25 16.5C7.25 15.8096 6.69036 15.25 6 15.25C5.30964 15.25 4.75 15.8096 4.75 16.5C4.75 17.1904 5.30964 17.75 6 17.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.53d5a6afc5da5378fc79c1be96e3c3bb.svg";
export { ForwardRef as ReactComponent };